import { Button, PrefetchLink, TwentyFourSocial } from '@/ui';

import { imageMetaConverter } from '@/lib/server';

import { FooterProps } from '.';

export function BottomFooter({
  siteName,
  policyLinks,
  operatorLogo,
  operatorHref,
}: Pick<FooterProps, 'siteName' | 'policyLinks' | 'operatorLogo' | 'operatorHref'>) {
  const year = new Date().getFullYear();
  const operatorLogoData = imageMetaConverter(operatorLogo);

  return (
    <div className="max-w-[theme(screens.3xl)] flex w-full flex-col items-start justify-between gap-3 px-4 py-4 text-xs font-medium lg:flex-row lg:items-center lg:gap-8 lg:px-8 lg:py-2">
      <p className={'flex-1'}>
        &copy; Copyright {year} {siteName}. All rights reserved.
      </p>

      {Boolean(policyLinks?.length) && (
        <ul className={'flex flex-1 flex-wrap gap-x-3 lg:justify-center'}>
          {policyLinks?.map((link) => (
            <li key={link.url}>
              <Button size={'sm'} className={'text-muted-foreground h-6 p-0 text-xs'} variant={'link'} href={link.url}>
                {link.label}
              </Button>
            </li>
          ))}
        </ul>
      )}

      <div className="flex flex-1 flex-wrap items-center gap-3 lg:justify-end">
        {operatorLogoData?.src && operatorHref && (
          <PrefetchLink className={'flex shrink-0 items-center gap-1'} href={operatorHref}>
            Operated by
            <img src={operatorLogoData.src} alt={operatorLogoData.alt} className="h-4" />
          </PrefetchLink>
        )}
        <span className={'border-border h-4 w-0 border-r'} />
        <PrefetchLink className={'flex shrink-0 items-center gap-1'} href={'https://www.24social.io/'}>
          Powered by
          <TwentyFourSocial />
        </PrefetchLink>
      </div>
    </div>
  );
}
